module.exports = __webpack_public_path__ + "img/symbol_1.a5c80e7d.png";